import { JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const putCustomerUnlink = async ({ taskId }: JsonDataItem) => {
  const data = await baseQuery('task/unlink-customer', {
    type: 'PUT',
    body: {
      task_ID: taskId,
    },
  });

  return data;
};
